<template>
  <div>
    <v-text-field :class="classe" v-model="time" :label="label ? $t('time') + ' ' + label : null"
      prepend-icon="mdi-clock-time-four-outline" @click:prepend="openDialog" hide-details="auto" :disabled="disabled"
      :rules="required ? requiredTime : null" @keyup="checkInput(false)" @blur="checkInput(true)">
    </v-text-field>
    <v-dialog ref="dialog" v-model="modalPicker" width="290px">
      <v-time-picker v-if="modalPicker" v-model="timeDialog" format="24hr" use-seconds full-width>
        <v-spacer></v-spacer>
        <v-btn text color="primary" @click="modalPicker = false">
          {{ $t('undo') }}
        </v-btn>
        <v-btn text color="primary" @click="save"> OK </v-btn>
      </v-time-picker>
    </v-dialog>
  </div>
</template>

<script>
import moment from "moment";

export default {
  name: "my-timepicker",
  props: {
    label: null,
    value: null,
    prependIcon: null,
    outlined: null,
    hint: null,
    persistentHint: false,
    required: false,
    disabled: false,
    dense: false,
    classe: null,
  },
  data: () => ({
    modalPicker: false,
    time: null,
    datePart: null,
    timeDialog: null,
    requiredTime: [(value) => !!value || "Required."],
  }),
  methods: {
    checkInput(pad = false) {
      this.time = this.time.replace(/[^\d:]/g, "");
      let arrTime = [];
      let tmpTime = this.time.split(":");
      for (let section of tmpTime) {
        do {
          let len = section.length > 1 ? 2 : 1;
          arrTime.push(section.substring(0, len));
          section = section.substring(len);
        } while (section.length > 0);
      }

      if (arrTime.length > 3) {
        arrTime = arrTime.slice(0, 3);
        pad = true;
      }

      // controllo range
      if (arrTime.length >= 1 && parseInt(arrTime[0]) > 24) {
        arrTime[0] = 23;
        arrTime[1] = 59;
        arrTime[2] = 59;
      }

      if (arrTime.length >= 2 && parseInt(arrTime[1]) > 59) {
        arrTime[1] = 59;
        arrTime[2] = 59;
      }
      if (arrTime.length == 3 && parseInt(arrTime[2]) > 59) {
        arrTime[2] = 59;
      }

      if (pad) {
        if (arrTime.length < 1) arrTime[0] = "00";
        if (arrTime.length < 2) arrTime[1] = "00";
        if (arrTime.length < 3) arrTime[2] = "00";
        arrTime = arrTime.map((section) => {
          return section.padStart(2, "0");
        });
      }

      this.time = arrTime.join(":");
      if (pad) {
        let offset = new Date().getTimezoneOffset();
        let dateTime = moment(this.datePart + " " + this.time, "YYYY-MM-DD HH:mm:ss").utc().format()
        this.$emit("input", dateTime);
      }
    },
    openDialog() {
      this.timeDialog = this.time;
      this.modalPicker = true;
    },
    save() {
      this.time = this.timeDialog;
      let offset = new Date().getTimezoneOffset();
      let dateTime = moment(this.datePart + " " + this.time, "YYYY-MM-DD HH:mm:ss").utc().format()
      this.$emit("input", dateTime);
      this.modalPicker = false;
    },
  },
  mounted() {
    if (this.value) {
      this.datePart = moment(this.value).format(moment.HTML5_FMT.DATE);
      this.time = new Date(this.value).toLocaleTimeString();
    } else {
      this.datePart = moment().format(moment.HTML5_FMT.DATE);
      this.time = new Date().toLocaleTimeString();
    }
  },
  watch: {
    value: function (newVal, oldVal) {
      if (newVal) {
        this.datePart = moment(newVal).format(moment.HTML5_FMT.DATE);
        this.time = new Date(newVal).toLocaleTimeString();
      } else {
        this.datePart = moment().format(moment.HTML5_FMT.DATE);
        this.time = new Date().toLocaleTimeString();
      }
    },
  },
};
</script>
